import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ImageService {
  private apiImagePath = environment.apiImagePath;
  
  constructor() {}

  getImagePath(relativeUrl:string): string {
    return this.apiImagePath + relativeUrl;
  }
 
}
